import type { GameSessionView } from '@creativitas/shared';

/** The next dice throw is queued before the previous player draws their cards. */
export function gameTurnPresentation(session: GameSessionView) {
  const latestRoll = session.actions.find((action) => action.type === 'dice_rolled' && !action.undoneAt);
  const requiredCardDraws = Number(latestRoll?.payload?.requiredCardDraws ?? 0);
  const completedCardDraws = latestRoll
    ? session.actions.filter((action) =>
        action.type === 'card_drawn' && !action.undoneAt && action.payload?.rollActionId === latestRoll.id,
      ).length
    : 0;
  const pendingCardDraws = Math.max(0, requiredCardDraws - completedCardDraws);

  return {
    latestRoll,
    completedCardDraws,
    pendingCardDraws,
    participantId: pendingCardDraws > 0
      ? session.lastDice?.participantId ?? session.currentTurnParticipantId
      : session.currentTurnParticipantId,
  };
}

/**
 * Люди за столом, а не записи.
 *
 * У ведущего служебная запись, и если он сел играть, появляется ещё игровое
 * место. Показывать оба — значит показать одного человека дважды. Место
 * ведущего сервер называет явно (`hostSeatParticipantId`), поэтому служебная
 * запись скрывается только тогда — по совпадению имён люди не объединяются.
 * Счётчик — игровые места: лимит шести считается по ним.
 */
export function roster(session: GameSessionView) {
  const seated = session.hostSeatParticipantId !== null;
  const people = session.participants.filter((participant) =>
    !(seated && participant.kind === 'facilitator'));
  const seats = session.participants.filter((participant) => participant.kind !== 'facilitator').length;
  return { people, seats };
}

/**
 * Свежее ли пришедшее состояние партии.
 *
 * Снимок по сокету собирается асинхронно и может прийти позже ответа на
 * следующую команду — тогда экран откатился бы на шаг назад: закрылась бы
 * только что открытая сказка, вернулась бы кнопка уже сделанного действия.
 * Каждая команда сервера увеличивает `stateVersion`, поэтому снимок старше
 * того, что уже на экране, просто не принимается. Равный — принимается: так
 * приходят изменения присутствия участников, которые версию не двигают.
 */
export function newerSnapshot(
  current: GameSessionView | undefined,
  incoming: GameSessionView,
): GameSessionView {
  if (current && current.id === incoming.id && incoming.stateVersion < current.stateVersion) return current;
  return incoming;
}
